import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { AccessControlListClient } from '@agilelab/plugin-wb-access-control-common';
import {
  accessControlListApiRef,
  actionHandlerApiRef,
  ActionHandlerClient,
} from '@agilelab/plugin-wb-access-control';
import { rootRouteRef } from './routes';
import { metricsApiRef } from '@agilelab/plugin-wb-metrics';
import { DefaultMetricsClient } from '@agilelab/plugin-wb-metrics-common';

export const marketplacePlugin = createPlugin({
  id: 'wb-marketplace',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: metricsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DefaultMetricsClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: actionHandlerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ActionHandlerClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: accessControlListApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AccessControlListClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const MarketplacePage = marketplacePlugin.provide(
  createRoutableExtension({
    name: 'MarketplacePage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
